import { jsx as _jsx } from "react/jsx-runtime";
import { AboutModal } from './AboutModal';
import { SupportModal } from './SupportModal';
import { HelpModal } from './HelpModal';
import { GlobalModals } from './Header';
import { useGlobalState } from '../../hooks';
import { LearningModal } from './LearningModal';
import { FeedbackModal } from './FeedbackModal';
import { ConfirmModal } from './ConfirmModal';
export function HandleModalDisplay(_a) {
    var productName = _a.productName, closeDropDown = _a.closeDropDown, closeModal = _a.closeModal, faqFolders = _a.faqFolders, qMarkData = _a.qMarkData;
    var global = useGlobalState();
    var globalModal = global.modalActive;
    switch (globalModal) {
        case GlobalModals.About:
            return (_jsx(AboutModal, { closeDropDown: closeDropDown, closeModal: closeModal }, void 0));
        case GlobalModals.Support:
            return (_jsx(SupportModal, { appName: productName, closeDropDown: closeDropDown, closeModal: closeModal }, void 0));
        case GlobalModals.Help:
            return (_jsx(HelpModal, { closeDropDown: closeDropDown, faqFolders: faqFolders || [{ label: 'Popular', faqName: 'worldPopular' }], helpLink: (qMarkData === null || qMarkData === void 0 ? void 0 : qMarkData.HelpLink) || 'https://help.evipscloud.com/' }, void 0));
        // case GlobalModals.IpsVideo:
        //   return <VideoModal />;
        case GlobalModals.Learning:
            return (_jsx(LearningModal, { closeDropDown: closeDropDown, courseName: productName, courses: (qMarkData === null || qMarkData === void 0 ? void 0 : qMarkData.world_app_courses) || [] }, void 0));
        case GlobalModals.Feedback:
            return (_jsx(FeedbackModal, { appName: productName, closeDropDown: closeDropDown, closeModal: closeModal }, void 0));
        case GlobalModals.Confirm:
            return _jsx(ConfirmModal, {}, void 0);
        default:
            return null;
    }
}
